export class BonTransportConstraint {

    existBonTransport?: string ;
    showBontransportButton?: string ;
    disableBontransportButton?: string ;

}